import { toast } from "react-toastify";
import axios, { AxiosInstance, AxiosRequestHeaders } from "axios";
import { useSessionStore } from "@/modules/auth/store/useSessionStore";

const ERRORS_TO_RETRY = [401];
const adminRoute = "/v1/admin/auth/refresh";

function HandleService(): AxiosInstance {
  const baseURL = import.meta.env.VITE_API_URL;

  const instance: AxiosInstance = axios.create({ baseURL });

  instance.interceptors.request.use((config) => {
    const accessToken = useSessionStore.getState().session?.accessToken;
    if (!config.headers.Authorization && accessToken) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      } as AxiosRequestHeaders;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const session = useSessionStore.getState().session;

      if (originalRequest?.url === adminRoute) {
        useSessionStore.getState().clearSession();
        toast.dismiss();
        return Promise.reject(error);
      }

      if (ERRORS_TO_RETRY.includes(error.response?.status) && !originalRequest._retry && session) {
        originalRequest._retry = true;
        const refreshToken = session.refreshToken;

        try {
          const { data } = await instance.post(adminRoute, undefined, {
            headers: { Authorization: `Bearer ${refreshToken}` },
          });

          useSessionStore.getState().setSession({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            user: data.user,
          });

          originalRequest.headers["Authorization"] = `Bearer ${data.accessToken}`;
          return instance(originalRequest);
        } catch {
          useSessionStore.getState().clearSession();
        }
      }
      return Promise.reject(error);
    },
  );

  return instance;
}

export default HandleService;
